import * as React from "react";
const ServerStoreDataContext = React.createContext({
  storeCode: void 0,
  globalStoreId: void 0
});
const useServerStoreDataContext = () => React.useContext(ServerStoreDataContext);
function withServerStoreDataContext() {
  return () => (PageComponent) => {
    const WithServerStoreDataContext = (pageProps) => {
      const value = React.useMemo(
        () => ({
          storeCode: pageProps?.storeData?.code,
          globalStoreId: pageProps?.storeData?.globalStoreId
        }),
        [pageProps?.storeData?.code, pageProps?.storeData?.globalStoreId]
      );
      return /* @__PURE__ */ React.createElement(ServerStoreDataContext.Provider, { value }, /* @__PURE__ */ React.createElement(PageComponent, { ...pageProps }));
    };
    if (typeof PageComponent.getInitialProps === "function") {
      WithServerStoreDataContext.getInitialProps = PageComponent.getInitialProps;
    }
    if (process.env.NODE_ENV !== "production") {
      const displayName = PageComponent.displayName || PageComponent.name || "Unknown";
      WithServerStoreDataContext.displayName = `WithServerStoreDataContext(${displayName})`;
    }
    return WithServerStoreDataContext;
  };
}
export {
  ServerStoreDataContext,
  useServerStoreDataContext,
  withServerStoreDataContext
};
//# sourceMappingURL=with-server-store-data-context.js.map
